/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * One Okta application in the snapshot, keyed by its Okta id.
 */
export type IdentityProviderConnectionApplication = {
  features: Array<string>;
  firstSeenAt: Date;
  /**
   * Live group assignments.
   */
  groupAssignments: number;
  /**
   * Admin-facing label. Admin-editable; never a key.
   */
  label: string;
  lastSeenAt: Date;
  /**
   * Okta application template name.
   */
  name: string;
  /**
   * Okta application id.
   */
  oktaAppId: string;
  /**
   * Set when the application disappeared from a run; only returned with include_removed.
   */
  removedAt?: Date | undefined;
  signOnMode: string;
  /**
   * ACTIVE or INACTIVE.
   */
  status: string;
  /**
   * Live direct and group-derived user assignments.
   */
  userAssignments: number;
};

/** @internal */
export const IdentityProviderConnectionApplication$inboundSchema: z.ZodMiniType<
  IdentityProviderConnectionApplication,
  unknown
> = z.pipe(
  z.object({
    features: z.array(z.string()),
    first_seen_at: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
    group_assignments: z.int(),
    label: z.string(),
    last_seen_at: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
    name: z.string(),
    okta_app_id: z.string(),
    removed_at: z.optional(
      z.pipe(z.iso.datetime({ offset: true }), z.transform(v => new Date(v))),
    ),
    sign_on_mode: z.string(),
    status: z.string(),
    user_assignments: z.int(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "first_seen_at": "firstSeenAt",
      "group_assignments": "groupAssignments",
      "last_seen_at": "lastSeenAt",
      "okta_app_id": "oktaAppId",
      "removed_at": "removedAt",
      "sign_on_mode": "signOnMode",
      "user_assignments": "userAssignments",
    });
  }),
);

export function identityProviderConnectionApplicationFromJSON(
  jsonString: string,
): SafeParseResult<IdentityProviderConnectionApplication, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) =>
      IdentityProviderConnectionApplication$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'IdentityProviderConnectionApplication' from JSON`,
  );
}
